module.exports = __webpack_public_path__ + "img/arrow-left-red.9739ee12.svg";